import React from "react";
import { useNavigate } from "react-router-dom";

export default function NotFound() {
  const navigate = useNavigate();

  return (
    <div className="mx-auto flex w-full max-w-7xl px-4 py-12 sm:px-6 lg:px-8">
      <div className="w-full max-w-xl rounded-2xl border border-slate-200 bg-white p-6 shadow-sm sm:p-8">
        <p className="mb-2 text-xs font-semibold uppercase tracking-[0.18em] text-cyan-600">
          SmartGage
        </p>

        <h1 className="text-2xl font-bold tracking-tight text-slate-900 sm:text-3xl">
          Página no encontrada
        </h1>

        <p className="mt-3 text-sm leading-6 text-slate-600">
          La dirección que intentaste abrir no existe en SmartGage.
        </p>

        <button
          onClick={() => navigate("/", { replace: true })}
          className="mt-6 h-10 rounded-lg bg-cyan-600 px-4 text-sm font-semibold text-white transition hover:bg-cyan-700"
        >
          Volver al Panel de Control
        </button>
      </div>
    </div>
  );
}